export default __webpack_public_path__ + "static/media/no-logs-selected.35a312a3.png";